export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";
export const SET_WISHLIST_ITEMS = "SET_WISHLIST_ITEMS";
export const CLEAR_WISHLIST = "CLEAR_WISHLIST";